import { PressableScale } from "pressto";
import { View } from "@src/components";
import { Image } from "expo-image";
import { useUnistyles } from "react-native-unistyles";
import { Icon } from "@src/components/Icon";

interface ClipThumbnailProps {
  thumbnailUrl: string;
  onPress: () => void;
}

export function ClipThumbnail({ thumbnailUrl, onPress }: ClipThumbnailProps) {
  const { theme } = useUnistyles();

  return (
    <PressableScale onPress={onPress}>
      <View rounded={theme.spacing["3xl"]} mb="xl" style={{ overflow: "hidden", position: "relative" }}>
        <Image
          source={{ uri: thumbnailUrl }}
          style={{
            width: "100%",
            height: theme.spacing["15xl"] * 2.3,
          }}
          contentFit="cover"
        />
        {/* Expand Button Overlay */}
        <View
          bg="surface"
          rounded={theme.spacing["11xl"]}
          p="md"
          shadow="lg"
          style={{
            position: "absolute",
            right: theme.spacing["3xl"],
            bottom: theme.spacing["3xl"],
          }}
        >
          <Icon name="fullscreen" size={theme.spacing["6xl"]} color={theme.colors.text as string} />
        </View>
      </View>
    </PressableScale>
  );
}
